import PropTypes from 'prop-types';

import {NAV_POSITION_BOTTOM, NAV_POSITION_TOP,} from '../constants';

export default PropTypes.oneOf([NAV_POSITION_BOTTOM, NAV_POSITION_TOP]);
